import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HttpError } from '@rd/types';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { RewardsPreferenceApiService } from '../../services/rewards-preference-api/rewards-preference-api.service';
import { RewardsPreference } from '../../types/rewards-preference.type';
import * as actions from '../actions/rewards-preference.actions';

@Injectable()
export class RewardsPreferenceEffects {
  constructor(
    private actions$: Actions,
    private rewardsPreferenceApiService: RewardsPreferenceApiService,
  ) {}

  loadRewardsPreference$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.RewardsPreferenceActionTypes.LOAD_REWARDS_PREFERENCE),
      switchMap((action: actions.LoadRewardsPreference) => {
        return this.rewardsPreferenceApiService.getRewardsPreference().pipe(
          map((rewardsPreference: RewardsPreference) => {
            return new actions.LoadRewardsPreferenceSuccess(rewardsPreference);
          }),
          catchError(
            (error: HttpError) =>
              of(new actions.LoadRewardsPreferenceSuccess(null)), // hardcode false for now
          ),
        );
      }),
    ),
  );

  createRewardsPreference$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.RewardsPreferenceActionTypes.CREATE_REWARDS_PREFERENCE),
      switchMap((action: actions.CreateRewardsPreference) => {
        return this.rewardsPreferenceApiService
          .createRewardsPreference(action.payload)
          .pipe(
            map((rewardsPreference: RewardsPreference) => {
              return new actions.CreateRewardsPreferenceSuccess(
                rewardsPreference,
              );
            }),
            catchError((error: HttpError) =>
              of(new actions.CreateRewardsPreferenceFail(error)),
            ),
          );
      }),
    ),
  );
}
